import { default as Body } from './Body'
import { default as Heading } from './Heading'
import { default as LogoText } from './LogoText'
import { default as NumericValue } from './NumericValue'

export { Body, Heading, LogoText, NumericValue }
